module.exports = __webpack_public_path__ + "img/app_all.828b17bc.png";